import { createStore } from 'redux';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { SystemState } from '../types';
import { rootReducer } from './reducers/rootReducer';

export const storeFactory = (preloadedState?: SystemState) =>
  createStore(rootReducer, preloadedState, composeWithDevTools());

const defaultStore = storeFactory();

type AppDispatch = typeof defaultStore.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<SystemState> = useSelector;

export default defaultStore;
